import Layout from "components/layout";
import { NextSeo } from "next-seo";
import { ReactNode } from "react";
import { TermsOfSaleLayout } from "shared/components/templates/TermsOfSaleLayout";

const TermsOfSale = () => <TermsOfSaleLayout />;

TermsOfSale.getLayout = (page: ReactNode) => {
  return (
    <>
      <NextSeo noindex />
      <Layout nav={null}>{page}</Layout>
    </>
  );
};

export default TermsOfSale;
